var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#212121",
    stroke: "#424242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_1145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0583 8.88889H9.93889C9.35833 8.88889 8.88889 9.34722 8.88889 9.91389V22.0833C8.88889 22.65 9.35833 23.1111 9.93889 23.1111H22.0583C22.6389 23.1111 23.1111 22.65 23.1111 22.0861V9.91389C23.1111 9.34722 22.6389 8.88889 22.0583 8.88889ZM13.1083 21.0083H10.9972V14.2194H13.1083V21.0083ZM12.0528 13.2944C11.375 13.2944 10.8278 12.7472 10.8278 12.0722C10.8278 11.3972 11.375 10.85 12.0528 10.85C12.7278 10.85 13.275 11.3972 13.275 12.0722C13.275 12.7444 12.7278 13.2944 12.0528 13.2944ZM21.0083 21.0083H18.9V17.7083C18.9 16.9222 18.8861 15.9083 17.8028 15.9083C16.7056 15.9083 16.5389 16.7667 16.5389 17.6528V21.0083H14.4333V14.2194H16.4556V15.1472H16.4833C16.7639 14.6139 17.4528 14.05 18.4778 14.05C20.6139 14.05 21.0083 15.4556 21.0083 17.2833V21.0083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_1145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 14.2222,
    fill: "white",
    transform: "translate(8.88889 8.88889)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e260fa528a0be7e4d5e7ebf50ebd372a.svg";
export { ForwardRef as ReactComponent };